import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IProjectEmail } from "../../utils/types/models";

export default createEntityReducer<IProjectEmail>(Endpoint.ProjectEmails, Endpoint.ProjectEmailsList);
